import {
  AgronomicActivityType,
  SeasonName,
  DataLegitimacyQuery,
} from '../requesters/agVizRequester/agVizQuery';
import { MachineDataMap } from '../requesters/agVizRequester/types';

export enum AgVizAction {
  RequestAgVizMaps = 'REQUEST_AG_VIZ_MAPS',
  ReceiveAgVizMaps = 'RECEIVE_AG_VIZ_MAPS',
  AgVizMapsFailure = 'AG_VIZ_MAPS_FAILURE',
}

export interface RequestAgVizMapsAction {
  type: AgVizAction.RequestAgVizMaps;
  fieldId: string;
  cropCode: string;
  seasonName: SeasonName;
  seasonYear: number;
  activityType: AgronomicActivityType;
  dataLegitimacy: DataLegitimacyQuery;
}

interface ReqAgVizMapsParams {
  fieldId: string;
  cropCode: string;
  seasonName: SeasonName;
  seasonYear: number;
  activityType: AgronomicActivityType;
  dataLegitimacy?: DataLegitimacyQuery;
}

export function reqAgVizMaps({
  fieldId,
  cropCode,
  seasonName,
  seasonYear,
  activityType,
  dataLegitimacy = DataLegitimacyQuery.LEGITIMATE
}: ReqAgVizMapsParams): RequestAgVizMapsAction {
  return {
    type: AgVizAction.RequestAgVizMaps,
    fieldId,
    cropCode,
    seasonName,
    seasonYear,
    activityType,
    dataLegitimacy,
  };
}

export interface ReceiveAgVizMapsAction {
  type: AgVizAction.ReceiveAgVizMaps;
  maps: MachineDataMap[];
  cropCode: string;
  seasonName: SeasonName;
  seasonYear: number;
  activityType: AgronomicActivityType;
}

interface ReceiveAgVizMapsParams {
  maps: MachineDataMap[];
  cropCode: string;
  seasonName: SeasonName;
  seasonYear: number;
  activityType: AgronomicActivityType;
}

export function receiveAgVizMaps({
  maps,
  cropCode,
  seasonName,
  seasonYear,
  activityType
}: ReceiveAgVizMapsParams): ReceiveAgVizMapsAction {
  return {
    type: AgVizAction.ReceiveAgVizMaps,
    maps,
    cropCode,
    seasonName,
    seasonYear,
    activityType,
  };
}

export interface AgVizMapsFailureAction {
  type: AgVizAction.AgVizMapsFailure;
  error?: string;
}

export function agVizMapsFailure(error?: string): AgVizMapsFailureAction {
  return {
    type: AgVizAction.AgVizMapsFailure,
    error,
  };
}

export type AgVizActions =
  | RequestAgVizMapsAction
  | ReceiveAgVizMapsAction
  | AgVizMapsFailureAction;
